var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.goPath(_vm.to, _vm.route)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }